import { useEffect } from "react";
import "./css/loginpopup.css";
import popupImg from "../../../assets/images/popup.png";

const LoginPopup = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="loginpopup-backdrop" onClick={onClose}>
      <div className="loginpopup-wrap" onClick={(e) => e.stopPropagation()}>
        <button className="loginpopup-close-btn" onClick={onClose}>✕</button>
        <img src={popupImg} alt="공지 팝업" className="loginpopup-img" />
      </div>
    </div>
  );
};

export default LoginPopup;
